











































import DictMixin from '@/mixins/dict-mixin';
import { SubjectDto } from '@/services/subject';
import { mixins } from 'vue-class-component';
import { Vue, Component, PropSync, Prop } from 'vue-property-decorator';

@Component
export default class SubjectForm1 extends mixins(DictMixin) {
  @PropSync('formData') syncFormData!: SubjectDto;
  @Prop() id!: any;
}
